import _ from "lodash"
import Convert from "utils/convert"
import APIs from "redux/apis"
// import { EXCHANGE } from "config/const"
import { TERM_EXTERNAL } from "components/pages/others/external/const"
import { getLegList } from "components/pages/others/external/utils"

// マージ対象とするTICK制限値(1000=最低１秒のTickはマージ対象とする)
export const PUSH_TICK_MAX = 1000
const EX_SECURITY_TYPE = 12000
const EX_EXCHANGE = 400
// const JAPAN = 1
// const AMERICA = 2
// const COUNTRY_CODE = {
//   JAPAN,
//   AMERICA,
// }

// Chart APIの戻り値
export interface resultObj {
  Chart: chartObj
  IsDelay: boolean
  MaxSeqNum: number
  Message: string
  MinSeqNum: number
  Result: number
  StartTime: string
  Symbol: symbolObj
}

interface chartObj {
  Columns: Array<string>
  LegList: Array<Array<string | number>>
}

// Chart APIのparamの基本情報
export interface chartApiReqObj {
  SecurityType: number
  Symbol: string
  Exchange: number
  LegType: string
  Symbolkey?: string
}
// Chart APIのparam
export interface chartApiParamObj extends chartApiReqObj {
  From?: string | null
  Count?: number | null
  WithoutSymbol?: boolean
}

interface legListObj {
  Close: number
  DatumTime: number
  DatumType: number
  High: number
  Low: number
  MarginBuying: number
  MarginSelling: number
  Open: number
  RealTime: number
  Volume: number
  Vwap: number | null
}

interface symbolObj {
  Ask: null | string | number
  Bid: null | string | number
  CalcLastClose: null | string | number
  ChangedPrice: null | string | number
  ChangedRatio: null | string | number
  ComplianceFlag: null | string | number
  Division: null | string | number
  Enable2Way: null | string | number
  Exchange: null | string | number
  ExchangeDivisions: null | string | number
  HighPrice: null | string | number
  HighPriceTime: null | string | number
  LastClose: null | string | number
  LastCloseTime: null | string | number
  LowPrice: null | string | number
  LowPriceTime: null | string | number
  MainExchange: null | string | number
  NumberOfDecimals: null | string | number
  OpenPrice: null | string | number
  OpenPriceTime: null | string | number
  Price: null | string | number
  PriceCompare: null | string | number
  PriceCompareText: null | string | number
  PriceStatus: null | string | number
  PriceTime: null | string | number
  SecurityType: null | string | number
  ShortSellingFlag: null | string | number
  Symbol: null | string | number
  SymbolCode: null | string | number
  SymbolName: null | string | number
  SymbolNameS: null | string | number
  TemporaryPost: null | string | number
  TradValue: null | string | number
  TradVolume: null | string | number
  VWAP: null | string | number
  Ticker: string
}

interface aLatestDateTimeObj {
  main?: number | null
  sub1?: number | null
  sub2?: number | null
  [key: string]: number | null
}

interface aRequesterIDObj {
  main?: number | null
  sub1?: number | null
  sub2?: number | null
  [key: string]: number | null
}

interface aReqSymbolObj {
  main?: chartApiReqObj | null
  sub1?: chartApiReqObj | null
  sub2?: chartApiReqObj | null
  [key: string]: chartApiReqObj | null
}

interface aLoopFObj {
  main?: Function | null
  sub1?: Function | null
  sub2?: Function | null
  [key: string]: Function | null
}

interface aChDatahandlerObj {
  main?: ChartHandlerObj | null
  sub1?: ChartHandlerObj | null
  sub2?: ChartHandlerObj | null
  [key: string]: ChartHandlerObj | null
}

interface ChartHandlerObj {
  onAll: Function
  onUpd: Function
  onAppend: Function
  OnAppend: Function
  OnInitial: Function
  OnUpdate: Function
}

// const GetSystemDay = (symbol: reqSymbolObj): number => {
//   const isJapan = symbol.Exchange === EXCHANGE.US_EQUITY.id ? false : true
//   // 開発出来次第、コメントアウト外す
//   // const { SystemProperty } = store.getState()
//   // if (SystemProperty) {
//   //   const sprop = _.get(SystemProperty, [
//   //     'api',
//   //     isJapan ? 0 : 100,
//   //     'SystemDay',
//   //   ])
//   //   if (sprop) return sprop
//   // }
//   return 20180507
// }

// const timeFrame = (time: Date, term: string, countryCode?: number): Date => {
//   let newTime: Date = new Date(time.getTime())
//   const im = newTime.getMinutes()

//   switch (term) {
//     case "1m":
//       newTime.setSeconds(0, 0)
//       break
//     case "60m":
//       newTime.setMinutes(0, 0, 0)
//       break
//     case "5m":
//     case "3m":
//     case "10m":
//       const termNum = Number(term.charAt(0)) === 1 ? 10 : Number(term.charAt(0))
//       const newim = im - (im % termNum)
//       newTime.setMinutes(newim, 0, 0)
//       break
//     case "1D":
//     case "1W":
//     case "1M":
//       let istartHour: number = 0
//       let istartHour1: number
//       let istartHour2: number
//       if (term === "1M") {
//         // 1M
//         // 月初めの0時以降は前月が対象になる
//         if (time.getDate() === 1 && time.getHours() <= 12) {
//           newTime.setMonth(
//             newTime.getMonth() === 0 ? 11 : newTime.getMonth() - 1
//           ) // getMonthは0-11
//         }
//         istartHour1 = 23
//         istartHour2 = 22
//       } else {
//         // 1Wのみ
//         if (term === "1W") {
//           const iDayOfWeek = newTime.getDay()
//           newTime.setDate(newTime.getDate() - iDayOfWeek + 1)
//         }
//         istartHour1 = 21
//         istartHour2 = 20
//       }

//       // 共通
//       if (countryCode === COUNTRY_CODE.AMERICA) {
//         // 米株
//         istartHour = istartHour1
//         if (isDaylightSavingTime(newTime)) {
//           istartHour = istartHour2
//         }
//       }
//       newTime.setHours(istartHour, 0, 0, 0)
//       break
//     case "15m":
//     case "20m":
//     case "30m":
//       const termMinute = Number(term.slice(0, 2))
//       if (im < termMinute) {
//         newTime.setMinutes(0, 0, 0)
//       } else if (im < termMinute * 2) {
//         newTime.setMinutes(termMinute, 0, 0)
//       } else if (im < termMinute * 3) {
//         newTime.setMinutes(termMinute * 2, 0, 0)
//       } else {
//         newTime.setMinutes(termMinute * 3, 0, 0)
//       }
//       break
//     case "T":
//     case "Tick":
//     default:
//       return time
//   }
//   return newTime
// }

// const isDaylightSavingTime = (dt: Date): boolean => {
//   const changeYear = new Date(2007, 0, 1)
//   let retval: boolean = false // 冬時間
//   if (dt >= changeYear) {
//     let dtPointer = new Date(dt.getFullYear(), 2, 1)
//     let isunday = 0
//     for (let i = 1; i < 32; i++) {
//       dtPointer.setDate(i)
//       if (dtPointer.getDay() === 0) {
//         isunday = isunday + 1
//       }
//       if (isunday >= 2) {
//         dtPointer.setDate(i + 1)
//         break
//       }
//     }
//     // 夏時間の開始日設定
//     const dtBegin = dtPointer
//     dtPointer = new Date(dt.getFullYear(), 10, 1)
//     for (let i = 1; i < 31; i++) {
//       dtPointer.setDate(i)
//       if (dtPointer.getDay() === 0) {
//         break
//       }
//     }
//     // 夏時間の終了日
//     const dtEnd = dtPointer
//     if (dt >= dtBegin && dt < dtEnd) {
//       retval = true
//     }
//   } else {
//     // 4月の第一日曜日の翌日(月)から10月の最後の日曜日の前々日(金曜日)まで夏時間
//     let dtPointer = new Date(dt.getFullYear(), 3, 1)
//     for (let i = 1; i < 32; i++) {
//       dtPointer.setDate(i)
//       if (dtPointer.getDay() === 0) {
//         // sunday
//         dtPointer.setDate(i + 1)
//         break
//       }
//     }
//     const dtBegin = dtPointer // 夏時間開始
//     dtPointer = new Date(dt.getFullYear(), 9, 31)
//     for (let j = 31; j >= 1; j--) {
//       dtPointer.setDate(j)
//       if (dtPointer.getDay() === 0) {
//         // sunday
//         break
//       }
//     }
//     const dtEnd = dtPointer // 夏時間終了
//     if (dt >= dtBegin && dt < dtEnd) {
//       retval = true
//     }
//   }
//   return retval
// }

class ChartProvider {
  setPriceInfo: Function | null
  setInitEndF: Function | null
  priorityFlag: boolean
  interval: number | null
  isMounted: boolean
  aLoopF: aLoopFObj
  aChDatahandler: aChDatahandlerObj
  aReqSymbol: aReqSymbolObj
  aLatestDateTime: aLatestDateTimeObj
  aRequesterID: aRequesterIDObj
  constructor(
    infoF: Function | null,
    setInitEndF?: Function | null,
    priorityFlag?: boolean
  ) {
    this.setPriceInfo = infoF ? infoF : null
    this.setInitEndF = setInitEndF ? setInitEndF : null
    this.priorityFlag = priorityFlag

    this.isMounted = false
    this.aLoopF = {}
    this.aChDatahandler = {} // チャートにデータを渡すハンドラー
    this.aLatestDateTime = {} // チャートデータの最後の足(時刻)
    this.aRequesterID = {} // ポーリング用のID
    this.aReqSymbol = {} // リクエストパラメータ(銘柄情報など）
    this.interval = null
    this.UnMount = this.UnMount
    this.Suspend = this.Suspend
    this.Resume = this.Resume
    this.UnRegistCh = this.UnRegistCh
  }

  // *********
  // APIで過去足取得用
  // *********
  async Request(
    reqSymbol: chartApiReqObj,
    from: string | null,
    count: number | null,
    symbolkey: string,
    fn: Function,
    priorityFlag?: boolean
    // WithoutSymbol: boolean = true,
  ): Promise<void> {
    let param: chartApiParamObj = {
      ..._.pick(reqSymbol, ["SecurityType", "Symbol", "Exchange", "LegType"]),
      // WithoutSymbol: WithoutSymbol,
    }
    if (!from && !count) return //過去足なしの場合は、fromが未定義になるので、余計なリクエストしない
    if (from !== null) param["From"] = from
    if (count !== null) param["Count"] = count

    if (this.isMounted === false) {
      return
    }

    //priorityData(オフィシャルサイトのマーケット情報のデータ)があれば優先的に使う。セッションのない状態なのでChartのAPIは呼ばない
    const result: resultObj = !priorityFlag
      ? await APIs.Chart.Chart(param)
      : await APIs.Chart.DelayChart(param)

    //  LegListのカラムが、"RealTime", "BusinessTime", "HighPrice", "LowPrice", "OpenPrice", "ClosePrice", "Volume", "VWAP", "VirtualLeg", ""
    //  の順で入っているとしている(本当はColumnsを見つつ判断するべき)

    if (result.Message === "銘柄の指定に誤りがあります。") {
      console.log(result.Message)
    }

    if (priorityFlag) {
      const termType = _.find(TERM_EXTERNAL, { key: param.LegType })
      // @ts-ignore
      result.Chart.LegList = getLegList(result, termType)
    }

    if (
      symbolkey === "main" &&
      this.setPriceInfo &&
      result.Symbol &&
      result.Chart &&
      result.Chart.LegList
    ) {
      // もし、ここでエラーが発生したら、以下コメントをはずすと、原因がわかりやすい（データ不正の可能性高い）
      //if (result.Chart.LegList.length > 0)
      //  console.log(result.Chart.LegList[result.Chart.LegList.length - 1])
      const pv =
        result.Chart.LegList.length > 0 &&
        result.Chart.LegList[result.Chart.LegList.length - 1].length >= 6
          ? result.Chart.LegList[result.Chart.LegList.length - 1][5]
          : 0
      this.setPriceInfo(
        // result.Symbol.Symbol,
        // result.Symbol.SecurityType,
        // result.Symbol.Exchange,
        result.Symbol.SymbolNameS,
        result.Symbol.Price,
        pv,
        result.Symbol.PriceTime,
        result.Symbol.LastClose
          ? result.Symbol.LastClose
          : result.Symbol.CalcLastClose,
        result.Symbol.ChangedRatio,
        result.Symbol.ChangedPrice,
        result.Symbol.Ticker,
        result.Symbol.PriceCompare,
        result.Symbol.LastCloseTime,
        result.Symbol.HighPrice,
        result.Symbol.HighPriceTime,
        result.Symbol.OpenPrice,
        result.Symbol.OpenPriceTime,
        result.Symbol.LowPrice,
        result.Symbol.LowPriceTime
      )
    }

    let LegList = result.Chart.LegList.map(
      (x): legListObj => {
        const dt = Date.parse(Convert.date(x[0], "yyyy/MM/dd HH:mm:ss"))
        return {
          DatumTime: dt,
          RealTime: dt,
          DatumType: x[8] as number,
          Open: x[4] as number,
          High: x[2] as number,
          Low: x[3] as number,
          Close: x[5] as number,
          Volume: x[6] as number,
          Vwap: x[7] as number,
          MarginBuying: x[9] ? (x[9] as number) : 0,
          MarginSelling: x[10] ? (x[10] as number) : 0,
        }
      }
    )
    let resSymbol = {
      SecurityType: param.SecurityType,
      Symbol: param.Symbol,
      Exchange: param.Exchange,
      LegType: param.LegType,
      Symbolkey: symbolkey,
    }
    fn(LegList, resSymbol)
  }

  callback = (
    datumList: Array<legListObj>,
    resSymbol: chartApiReqObj
  ): void => {
    const { Symbolkey } = resSymbol

    // 非同期で異なる銘柄のチャートを受け取らないようにする
    if (!_.isEqual(this.aReqSymbol[Symbolkey], resSymbol)) {
      return
    }
    datumList.forEach(datum => {
      if (this.aReqSymbol[Symbolkey].Symbol !== resSymbol.Symbol) {
      }

      if (this.aLatestDateTime[Symbolkey] === datum.DatumTime) {
        this.RaiseChOnUpdate(datum, Symbolkey)
      } else {
        if (this.aLatestDateTime[Symbolkey] > datum.DatumTime) return
        this.RaiseChOnAppend(datum, Symbolkey)
      }
      this.aLatestDateTime[Symbolkey] = datum.DatumTime
    })
    if (this.aChDatahandler[Symbolkey] !== null)
      this.aRequesterID[Symbolkey] = window.setTimeout(
        this.aLoopF[Symbolkey],
        this.interval * 1000
      )
  }

  RegistCh(sInfo: any, dataHandler: any): void {
    const {
      securityType,
      symbol,
      exchange,
      interval,
      count,
      legType,
      symbolkey = "main",
    } = sInfo.symbolKey
    this.interval = interval
    // 送信時の銘柄
    const reqSymbol = {
      SecurityType: securityType,
      Symbol: symbol,
      Exchange: securityType === EX_SECURITY_TYPE ? EX_EXCHANGE : exchange,
      LegType: legType,
      Symbolkey: symbolkey,
    }

    this.aChDatahandler[symbolkey] = dataHandler // チャートにデータを渡すハンドラー
    this.aReqSymbol[symbolkey] = reqSymbol // リクエストパラメータ(銘柄情報など）
    this.aLatestDateTime[symbolkey] = null // チャートデータの最後の足(時刻)
    this.aRequesterID[symbolkey] = null // ポーリング用のID

    this.Request(
      reqSymbol,
      null,
      count,
      symbolkey,
      (datumList: Array<legListObj>, resSymbol: chartApiReqObj) => {
        let arr: Array<legListObj> = []
        // 非同期で異なる銘柄のチャートを受け取らないようにする
        if (!_.isEqual(this.aReqSymbol[symbolkey], resSymbol)) {
          return
        }

        datumList.forEach(datum => {
          arr.push(datum)
          this.aLatestDateTime[symbolkey] = datum.DatumTime
        })
        this.RaiseChOnInitial(arr, symbolkey)
        this.aLoopF[symbolkey] = () => {
          if (!_.isEqual(this.aReqSymbol[symbolkey], resSymbol)) return
          this.Request(
            reqSymbol,
            this.aLatestDateTime[symbolkey]
              ? Convert.date(this.aLatestDateTime[symbolkey], "yyyyMMddHHmmss")
              : null,
            null,
            symbolkey,
            this.callback
          )
        }
        // 300本後、すぐリクエストすると500エラー発生するので、差分リクエストなので、5秒後リクエストするようにする
        //priorityData(オフィシャルサイトのマーケット情報のデータ)。セッションのない状態なのでポーリングさせない
        if (!this.aLatestDateTime[symbolkey] || this.priorityFlag) return // 過去足がないか、不正銘柄なので、ポーリングしない（でないと、意味のないポーリングを続けてしまう）
        if (this.aLoopF[symbolkey]) setTimeout(this.aLoopF[symbolkey], 5000)
      },
      this.priorityFlag
    )
  }

  UnRegistCh(symbolInfo: any | null = null): void {
    if (symbolInfo) {
      const key = symbolInfo.symbolKey.symbolKey
      if (key && key !== "main") {
        if (this.aChDatahandler[key]) this.aChDatahandler[key] = null
        if (this.aReqSymbol[key]) this.aReqSymbol[key] = null
        if (this.aLatestDateTime[key]) this.aLatestDateTime[key] = null
        if (this.aRequesterID[key]) {
          clearTimeout(this.aRequesterID[key])
          this.aRequesterID[key] = null
        }
      }
    } else {
      _.map(["main", "sub1", "sub2"], key => {
        if (this.aChDatahandler[key]) this.aChDatahandler[key] = null
        if (this.aReqSymbol[key]) this.aReqSymbol[key] = null
        if (this.aLatestDateTime[key]) this.aLatestDateTime[key] = null
        if (this.aRequesterID[key]) {
          clearTimeout(this.aRequesterID[key])
          this.aRequesterID[key] = null
        }
      })
    }
  }

  UnMount(): void {
    this.UnRegistCh()
    this.setPriceInfo = null
  }

  // チャートデータ入替
  RaiseChOnInitial(array: Array<legListObj>, key: string): void {
    const registedChDatahandler = this.aChDatahandler[key]
    const reqSymbol = this.aReqSymbol[key]
    if (registedChDatahandler === null) return

    registedChDatahandler.OnInitial(array)

    this.aLatestDateTime[key] = array.length
      ? array[array.length - 1].DatumTime
      : null

    // データ設定後の処理
    // テクニカル設定を行えるようにする
    if (this.setInitEndF) this.setInitEndF(reqSymbol)
  }

  // チャートデータ足追加
  RaiseChOnAppend(price: legListObj, key: string): void {
    const registedChDatahandler = this.aChDatahandler[key]
    if (registedChDatahandler === null) return
    registedChDatahandler.OnAppend(price)
    this.aLatestDateTime[key] = price.DatumTime
  }

  // チャートデータ足更新
  RaiseChOnUpdate(price: legListObj, key: string): void {
    const registedChDatahandler = this.aChDatahandler[key]
    if (registedChDatahandler === null) return
    registedChDatahandler.OnUpdate(price)
    this.aLatestDateTime[key] = price.DatumTime
  }

  Suspend(): void {
    _.map(["main", "sub1", "sub2"], key => {
      if (this.aRequesterID[key]) clearTimeout(this.aRequesterID[key])
    })
  }

  Resume(): void {
    _.map(["main", "sub1", "sub2"], key => {
      if (this.aRequesterID[key]) {
        clearTimeout(this.aRequesterID[key])
        if (this.aLoopF[key]) this.aLoopF[key]()
      }
    })
  }
}
export default ChartProvider
